/**
 * JK Loom web app — Firebase Console → Project **jk-presence** → Project settings → Your apps → Web.
 * Must match Android `app/google-services.json` (`project_id`: jk-presence).
 * Override via `console/main/.env` (REACT_APP_FIREBASE_*) if you register a new web app.
 */
export const JK_PRESENCE_FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDgG9MsHQKkyKK6YrM1mYvSvugJKeJIFPA',
  authDomain: 'jk-presence.firebaseapp.com',
  projectId: 'jk-presence',
  storageBucket: 'jk-presence.firebasestorage.app',
  messagingSenderId: '899029802045',
  appId: '1:899029802045:web:303df7456d8dbcc77c1e54',
  measurementId: 'G-31GF88HYF3',
} as const;
